// router.js
import React from "react";
import { createBrowserRouter } from "react-router-dom";
import AuthenticatedRoute from "./App";
import { routes } from "./routes";

export const router = createBrowserRouter(
  routes.map((route) => ({
    path: route.path,
    element: (
      <AuthenticatedRoute
        authenticate={route.authenticate}
        title={route.title}
        useTitleId={route.useTitleId}
        element={route.element}
      />
    ),
  }))
);
